import {checkStatus} from '../../__utils/utils'

export const sendEsputnikData = formRequest => {
  const {name, email, phone, company, isSubscribe, formType = 'subscribeRu', groups} = formRequest

  const [firstName, lastName] = name
    ? name.split(' ')
    : ['', '']

  const data = {
    contact: {
      firstName,
      lastName: lastName || firstName,
      channels: [
        {
          type: 'email',
          value: email
        },
        {
          type: 'sms',
          value: phone
        }
      ],
      fields: [
        {
          id: 133491,
          value: company || ''
        },
        {
          id: 133316,
          value: document.location.href
        },
        {
          id: 133501,
          value: isSubscribe
            ? 'Подписка на рассылки'
            : ''
        }
      ]
    },
    groups: groups
      ? groups
      : [formType],
    formType
  }

  return fetch('https://api.selectel.ru/proxy/public/esputnik/v1/contact/subscribe', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(checkStatus)
}